
import {
  SET,
  REINIT
} from './types';

import {
  Actions,
} from './actions';

import {
  AlertsModel
} from './alertsmodel';

export const alertstate = (
  context: any,
  initial?:AlertsModel[],
) => {
  const initValue = initial || [];

  return (
      state: AlertsModel[] = initValue,
      action:Actions,
  ) => {
      const {
          type,
          payload,
      } = action;
      let updated = state;
      switch (type) {
          case SET:
              updated = payload
              break;

          case REINIT:
              updated = initValue;
              break;
      }
      return updated;
  }
};